import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ConfirmDialogOptions, ConfirmDialogComponent } from './confirm-dialog.component';


export interface CurrentDialogData {
  component: any,
  props: any
}


/**
 * Service to show dialogs
 */
@Injectable()
export class DialogService {

  private _currentDialog = new Subject<CurrentDialogData>();

  constructor() {

  }

  get currentDialog() {
    return this._currentDialog;
  }

  set currentDialog(value) {
    // Ignore
  }

  // Shows confirmation dialog
  confirm(opts: ConfirmDialogOptions): Observable<boolean> {
    let subject = new Subject<boolean>();

    // Build a new dialog data
    let dialogData = {
      component: ConfirmDialogComponent,
      props: Object.assign({}, opts, {
        onConfirm: (result: boolean) => {
          // Return the confirm result
          subject.next(result);

          // Close the dialog
          this.hide();
        }
      })
    };

    // Show the new dialog
    this.show(dialogData);

    return subject;
  }

  // Shows delete confirmation dialog
  confirmDelete(message: string = 'Voulez-vous supprimer cet élément?') {
    return this.confirm({
      title: 'Suppression',
      message,
      confirm_button_class: 'btn-danger',
      confirm_button_text: 'Supprimer',
    });
  }

  // Shows a dialog
  show(dialogData: CurrentDialogData) {
    this._currentDialog.next(dialogData);
  }

  // Hides the current dialog
  hide() {
    // Close the dialog by sending empty dialog data
    this._currentDialog.next();
  }
}